export default __webpack_public_path__ + "cae3b67444022372bd4a8a20e9c5ca27.gif";